export default __webpack_public_path__ + "static/media/bas-cutout.2c3f025e.png";